<div class="tabs-wrapper d-flex align-items-center justify-content-between"
     [ngClass]="[tabCssClass || '', 'nav-tabs-sticky']">
    <div class="flex-grow-1 h-100">
        <ul ngbNav #nav="ngbNav" class="nav-underline h-100"
            [ngClass]="{
          'is-admin': reduceHorizontalSpacing,
          'justify-content-center': areTabsCentered
        }"
            [class.mb-3]="reduceHorizontalSpacing"
            [(activeId)]="active"
            (navChange)="onNavChange($event)">
            <ng-container *ngFor="let tab of tabs; trackBy: trackByItemId">
                <li [ngbNavItem]="tab.itemId" class="d-flex">
                    <a *ngIf="useRouterOutlet" ngbNavLink class="d-flex align-items-center"
                       [routerLink]="tab.route"
                       [queryParams]="tab.queryParams"
                       [queryParamsHandling]="queryParamsHandling"
                       [routerLinkActive]="'active'">
                        <ng-container *ngTemplateOutlet="tabButton; context: { tab: tab }"></ng-container>
                    </a>
                    <a *ngIf="!useRouterOutlet" ngbNavLink class="d-flex align-items-center">
                        <ng-container *ngTemplateOutlet="tabButton; context: { tab: tab }"></ng-container>
                    </a>

                    <ng-template #tabButton let-tab="tab">
                        <div class="fs-14-16 px-2 px-xl-0 fw-normal d-flex align-items-center">
                            {{tab.title}}
                            <ng-container *ngIf="tab.showIndicator">
                                <div class="indicator-box">
                                    <app-checkmark-indicator [isChecked]="tab.isChecked"></app-checkmark-indicator>
                                </div>
                            </ng-container>
                        </div>
                    </ng-template>

                    <ng-template ngbNavContent *ngIf="!useRouterOutlet">
                        <ng-container *ngTemplateOutlet="tab.content"></ng-container>
                    </ng-template>
                </li>
            </ng-container>
        </ul>
    </div>
    <ng-content></ng-content>
</div>

<div *ngIf="!useRouterOutlet" [ngbNavOutlet]="nav"></div>
<router-outlet *ngIf="useRouterOutlet"></router-outlet>